import PayPal from './PayPal/'
import Stripe from './Stripe/'
import Square from './Square/'

const integrations = {}
integrations[PayPal.guid] = PayPal
integrations[Stripe.guid] = Stripe
integrations[Square.guid] = Square

export default integrations
